// due_date is stored as a DATE in the DB; the JSON comes back as
// "YYYY-MM-DDT00:00:00Z". new Date() parses that as UTC midnight, which
// lands on the previous calendar day in negative-UTC timezones. Parse the
// YYYY-MM-DD piece as a local date so the value matches <input type="date">.

export function parseDueDate(iso?: string | null): Date | null {
    if (!iso) return null;
    const ymd = iso.split('T')[0];
    const [y, m, d] = ymd.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
}

export function formatDueDate(iso?: string | null, opts?: Intl.DateTimeFormatOptions): string {
    const dt = parseDueDate(iso);
    return dt ? dt.toLocaleDateString(undefined, opts) : '';
}

export function toDateInputValue(iso?: string | null): string {
    if (!iso) return '';
    return iso.split('T')[0];
}

export function isDueDateOverdue(iso?: string | null): boolean {
    const dt = parseDueDate(iso);
    if (!dt) return false;
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return dt < today;
}
